<template>
	<div>
		<!-- 顶部栏 -->
		<div class="topbar">
			<div>
				<el-input v-model="searchValue" size="small" placeholder="" prefix-icon="el-icon-search"
					class="search-input" @keypress.enter.native="search()" />
				<el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
					@click.stop="search()">
					搜索
				</el-button>

				<el-select style="padding-left: 20px;" clearable v-model="curCreditRulesType" @change="curCreditRulesChange">
					<el-option v-for="item in creditRulesTypeOptons" :key="item" :value="item"
						:label="item | creditRulesTransform"></el-option>
				</el-select>
			</div>
			<el-button type="primary" icon="el-icon-plus" size="small" @click.stop="openAddCreditRulesDialog()">
				新增规则
			</el-button>
		</div>
		<!-- 内容 -->
		<el-table border v-loading="loading" :data="creditRulesList" :header-cell-style="{ background: '#F5F7FA' }"
			style="width: 100%; margin-bottom: 20px;table-layout:fixed">
			<el-table-column prop="creditRuleID" label="#" align="center" width="100" />
			<el-table-column prop="creditRuleContent" label="积分规则内容" align="center" />
			<el-table-column prop="creditRuleType" label="类型" align="center">
				<template #default="scope">
					{{scope.row.creditRuleType | creditRulesTransform}}
				</template>
			</el-table-column>
			<el-table-column prop="creditValue" label="积分值" align="center" />
			<el-table-column prop="creditUpperValue" label="积分值上限" align="center" />
			<el-table-column prop="isSetCreditUpper" label="积分是否设置每天上限" align="center">
				<template #default='scope'>
					<el-switch v-model="scope.row.isSetCreditUpper" @change="setCreditUpperChange(scope.row)">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column prop="experiencePoint" label="经验值" align="center" />
			<el-table-column prop="experienceUpperPoint" label="经验值上限" align="center" />
			<el-table-column prop="isSetExperienceUpper" label="经验是否设置每天上限" align="center">
				<template #default='scope'>
					<el-switch v-model="scope.row.isSetExperienceUpper" @change="setExperienceUpperChange(scope.row)">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="开始时间" align="center">
				<template slot-scope="scope">
					{{ scope.row.startCreditTime | formatDateTime }}
				</template>
			</el-table-column>
			<el-table-column label="结束时间" align="center">
				<template slot-scope="scope">
					{{ scope.row.endCreditTime | formatDateTime }}
				</template>
			</el-table-column>
			<el-table-column label="删除时间" align="center">
				<template slot-scope="scope">
					{{ scope.row.deleteTime | formatDateTime }}
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="250">
				<template slot-scope="scope">
					<el-button size="small" type="primary" @click.stop="openEditCreditRulesDialog(scope.row)">
						编辑
					</el-button>
					<el-button size="small" :type="scope.row.isDeleted ? 'warning' : 'danger'"
						@click.stop="deleteCreditRuleOrBack(scope.row)">
						{{ scope.row.isDeleted ? "恢复" : "删除" }}
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination v-show="totalCount > pageSize" background layout="prev, pager, next" :total="totalCount"
			:page-size="pageSize" :current-page="currentPage" @current-change="currentChange" />

		<!-- showEditCreditRulesDlg -->
		<el-dialog title="新增积分规则" :visible.sync="showEditCreditRulesDlg" width="40%">
			<el-form ref="editCreditRulesFormRef" :model="editCreditRulesForm" status-icon>
				<el-form-item label="规则内容">
					<el-input v-model="editCreditRulesForm.creditRuleContent" type="textarea" />
				</el-form-item>

				<el-form-item label="规则类型">
					<el-select v-model="editCreditRulesForm.creditRuleType">
						<el-option v-for="item in creditRulesTypeOptons" :key="item" :value="item"
							:label="item | creditRulesTransform"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="积分值(保存后无法修改)">
					<el-input-number :disabled="editCreditRulesType === 'edit'"
						v-model="editCreditRulesForm.creditValue"></el-input-number>
				</el-form-item>
				<el-form-item label="积分是否设置每天上限">
					<el-switch v-model="editCreditRulesForm.isSetCreditUpper"></el-switch>
				</el-form-item>
				<el-form-item v-if="editCreditRulesForm.isSetCreditUpper" label="积分上限值">
					<el-input-number v-model="editCreditRulesForm.creditUpperValue"></el-input-number>
				</el-form-item>

				<el-form-item label="经验值(保存后无法修改)">
					<el-input-number :disabled="editCreditRulesType === 'edit'"
						v-model="editCreditRulesForm.experiencePoint"></el-input-number>
				</el-form-item>
				<el-form-item label="经验是否设置每天上限">
					<el-switch v-model="editCreditRulesForm.isSetExperienceUpper"></el-switch>
				</el-form-item>
				<el-form-item v-if="editCreditRulesForm.isSetExperienceUpper" label="经验上限值">
					<el-input-number v-model="editCreditRulesForm.experienceUpperPoint"></el-input-number>
				</el-form-item>
				<el-form-item label="开始时间">
					<el-date-picker v-model="editCreditRulesForm.startCreditTime" value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>

				</el-form-item>
				<el-form-item label="结束时间">
					<el-date-picker v-model="editCreditRulesForm.endCreditTime" value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>

				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="showEditCreditRulesDlg = false">
					取 消
				</el-button>
				<el-button type="primary" size="small" @click="handleCreateOrEditCreditRules()">
					确 定
				</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		deepClone
	} from "@/utils/index"
	import {
		addCreditRule,
		creditRuleDeleteOrBack,
		getCreditRuleList,
		updateCreditRule
	} from "@/api/CreditRule/CreditRule"
	import {isVaild} from "@/utils/validate"
	import {
		printObj
	} from "@/utils/debug"
	export default {
		data() {
			return {
				loading: false,
				pageSize: 10,
				currentPage: 1,
				totalCount: 0,
				searchValue: "",
				creditRulesList: [],
				showEditCreditRulesDlg: false,
				editCreditRulesType: "",
				editCreditRulesForm: {},
				creditRulesTypeOptons: [0, 1, 2, 3],
				curCreditRulesType:""
			}
		},
		created() {
			this.getCreditRulesList()
		},
		methods: {
			curCreditRulesChange(){
				this.search()
			},
			search() {
				this.currentPage = 1
				this.getCreditRulesList()
			},
			currentChange(page) {
				this.currentPage = page
				this.getCreditRulesList()
			},
			getCreditRulesList() {
				let para = {
					pageSize: this.pageSize,
					pageNumber: this.currentPage,
					keyWord: this.searchValue
				}
				if(isVaild(this.curCreditRulesType)){
					para.where = [{
						"field": "creditRuleType",
						"value": this.curCreditRulesType,
						"op": "equal"
					}]
				}

				getCreditRuleList(para).then(res => {
					this.loading = false;
					if (res.code === 200) {
						this.creditRulesList = res.data.rows
						this.totalCount = res.data.total
					} else {
						this.$message.warning(res.message)
					}
				}).catch(e => {
					this.loading = false;
				})
			},
			openAddCreditRulesDialog() {
				this.editCreditRulesType = 'create'
				this.showEditCreditRulesDlg = true
				this.editCreditRulesForm = {}
			},
			openEditCreditRulesDialog(entity) {
				this.editCreditRulesType = 'edit'
				this.showEditCreditRulesDlg = true
				this.editCreditRulesForm = deepClone(entity) 
			},
			setCreditUpperChange(entity) {
				this.updateCreidtRules(entity)
			},
			setExperienceUpperChange(entity) {
				this.updateCreidtRules(entity)
			},
			updateCreidtRules(entity) {
				printObj(entity)
				updateCreditRule(entity).then((res) => {
					if (res.code === 200) {
						this.$message.success("修改成功")
						this.getCreditRulesList()
					} else {
						this.$message.warning(res.message)
					}
				})
			},
			deleteCreditRuleOrBack(entity) {
				console.log("creditRuleId " + entity.creditRuleId)
				printObj(entity)
				creditRuleDeleteOrBack({
					creditRuleId: entity.creditRuleID
				}).then(res => {
					if (res.code === 200) {
						this.getCreditRulesList()
					} else {
						this.$message.warning(res.message)
					}
				})
			},
			handleCreateOrEditCreditRules() {
				if (this.editCreditRulesType === 'create') {
					addCreditRule(this.editCreditRulesForm).then((res) => {
						if (res.code === 200) {
							this.$message.success('添加成功')
							this.showEditCreditRulesDlg = false
							this.search()
						} else {
							this.$message.warning(res.message)
						}
					})
				} else if (this.editCreditRulesType === 'edit') {
					updateCreditRule(this.editCreditRulesForm).then((res) => {
						if (res.code === 200) {
							this.$message.success('修改成功')
							this.showEditCreditRulesDlg = false
							this.getCreditRulesList()
						} else {
							this.$message.warning(res.message)
						}
					})
				}
			}
		},
	}
</script>

<style>
</style>
